module.exports = __webpack_public_path__ + "img/21_50.f2701f22.png";